export default "__VITE_ASSET__VfeDSq8M__"